/**
 * @NOTICE this is a temp hack / fix to cap the number of points earned for the le_tour product type
 */
export const LOYALTY_TOUR_CAPPED_EARN_POINTS_TOTAL = 140_000

/**
 * @NOTICE this is a temp hack / fix to cap the number of status credits earned for the le_tour product type
 */
export const LOYALTY_TOUR_CAPPED_EARN_STATUS_CREDITS_TOTAL = 650

/**
 * @dev temporary campaign for earn key for hotel LPC Ultra Lux
 */
export const LOYALTY_ULTRA_LUX_CAMPAIGN_EARN_KEY = 'PT=tactical_ao_hotel&C=ultraLux'

/**
 * @dev earn key for flights Gardua bonus points campaign
 */
export const LOYALTY_GARUDA_BONUS_POINTS_CAMPAIGN_EARN_KEY = 'c=GarudaTriplePoints'

export const LOYALTY_VIC_DOUBLE_POINTS_CAMPAIGN = {
  earnKey: 'pt=accommodation&c=double-points',
  startDate: '2026-05-28T00:00:00+10:00',
  endDate: '2026-06-04T23:59:59+10:00',
} as const
